import { render } from "./CardsFav.vue?vue&type=template&id=456b28d1"
import script from "./CardsFav.vue?vue&type=script&lang=js"
export * from "./CardsFav.vue?vue&type=script&lang=js"

import "./CardsFav.vue?vue&type=style&index=0&id=456b28d1&lang=scss"

import exportComponent from "/opt/app-root/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__